import React from 'react';
import styled from "styled-components";
import ErrorPackage from "../../../images/errorPackage.png";
import ErrorPhone from "../../../images/errorPhone.png";

const ErrorMessageStyled = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    

   .headere{
        font-size: 1.8rem;
        font-weight: 700;
        color: #1B1E1C;
        font-family: ${props => props.theme.fonts.heading};
    }

    .retry-button {
        font-size: 1.3rem;
        font-weight: 700;
        color: #008755;
        cursor: pointer;
        text-decoration: underline;
    }

    & > p {
        width: 34rem;
        font-size: 1.4rem;
        font-weight: 400; 
        color: #757575;
        text-align: center;
        margin: 0;
    }

    @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
        width: 42rem;
	}
`;



const ErrorMessage = ({ message, tryAgainEvent, isPhone }) => {
    return (
        <ErrorMessageStyled className="error-message">
            <img src={isPhone ? ErrorPhone :ErrorPackage} alt="error package" />
            <span className='headere'>Oops, something went wrong</span>
            <p>{message}</p>
            <span onClick={() => tryAgainEvent()} className='retry-button'>Please try again</span>
        </ErrorMessageStyled>
    );
};

export default ErrorMessage;